import { createContext, useContext, useState } from "react";

const initialState = {
  isDarkMode: true,
};

const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
  const [state, setState] = useState({ ...initialState });

  const value = {
    ...state,
    toggleTheme: () => {
      setState({ isDarkMode: !state?.isDarkMode });
    },
    reset: () => setState({ ...initialState }),
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);
